import { useQuery } from "@tanstack/react-query";
import { getProtectionZoneSummary } from "../../api/captures/protectionZone";

export const useProtectionZoneSummary = (entityIdStr?: string) => {
  const entityId = Number(entityIdStr);

  const result = useQuery({
    queryKey: ["managementUnit", entityId, "protectionZoneSummary"],
    queryFn: () => getProtectionZoneSummary(entityId),
    enabled: !!entityId,
  });

  return {
    protectionZoneSummaryData: result.data,
    isPending: result.isPending,
    isError: result.isError,
    error: result.error,
    refetch: result.refetch,
  };
};
